import { Button } from "react-bootstrap";
import { openInNewTab } from "../Utils/utils";
import { FaWhatsapp } from "react-icons/fa";

const Boton = ({ title, callback, icon, style, size = 17 }) => {
  const handleClick = () => {
    if (typeof callback === "function") {
      callback();
    } else if (callback) {
      openInNewTab(callback);
    }
  };

  return (
    <Button className={`btn customBtn ${style}`} onClick={handleClick}>
      <div className="d-flex justify-content-center align-items-center align-content-center" style={{ fontSize: size }}>
        {icon && <FaWhatsapp className="me-2" />}
        {title}
      </div>
    </Button>
  );
};

export default Boton;
